export const UserChallengeState = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  TODO: 'TODO',
  GRADING_SOLUTION: 'GRADING_SOLUTION'
};
